import { memo, useCallback } from 'react';
import { Pressable } from 'react-native';
import {
  interpolate,
  useSharedValue,
  useAnimatedStyle,
  withSequence,
  withTiming,
  withRepeat,
} from 'react-native-reanimated';
import { Box, Image } from '@betty/moonlight';
import { PromoContainerProps } from './PromoContainer.types';

function PromoContainer({
  locked,
  selected,
  children,
  onPress,
}: PromoContainerProps) {
  const animatedValue = useSharedValue(0);
  const animatedStyle = useAnimatedStyle(() => ({
    transform: [
      { translateX: interpolate(animatedValue.value, [-1, 1], [-3, 3]) },
    ],
  }));

  const handlePress = useCallback(() => {
    if (!locked) {
      onPress();

      return;
    }

    animatedValue.value = withRepeat(
      withSequence(
        ...[0, 1, -1].map((value) => withTiming(value, { duration: 50 })),
      ),
      3,
      true,
    );
  }, [locked, animatedValue, onPress]);

  return (
    <Pressable onPress={handlePress}>
      <Box
        flexDirection="row"
        backgroundColor="primaryBackground"
        borderRadius="radius-200"
        padding="space-400"
        gap="space-400"
        centerContent
      >
        {selected && (
          <Box variant="outline-gradient" position="absolute" inset={0} />
        )}
        {children}
        <Box animatedStyle={animatedStyle}>
          <Image
            name={
              locked
                ? 'wallet.lock'
                : `wallet.${selected ? 'checked' : 'unchecked'}`
            }
            width="space-600"
            height="space-600"
          />
        </Box>
      </Box>
    </Pressable>
  );
}

export default memo(PromoContainer);
